module.exports = __webpack_public_path__ + "static/img/baisexi.8fc1b1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/baisexi.png
// module id = Gtf4
// module chunks = 3